// These functions must only set state values.
// They all generally do the same thing - only commit a state when the value is going to change.
// They are referenced from various actions so they are all gathered here.

export function setBooting(sm, isBooting) {
    if (sm.state['booting'] !== isBooting) {
        sm.commit('booting', isBooting)
    }
}

// When the current pane is about to change we store the previous currentPaneId.
export function setCurrentPane(sm, pane) {
    if (sm.state['currentPaneId'] !== pane.identifier) {
        sm.commit('currentPaneId', pane.identifier)
    }
}

export function clearCurrentPane(sm) {
    if (sm.state['currentPaneId'] !== null) {
        sm.commit('currentPaneId', null)
    }
}

export function setPrevPane(sm, pane) {
    if (sm.state['currentPaneId'] !== pane.identifier) {
        sm.commit('prevPaneId', sm.state['currentPaneId'])
    } // Only set the prev pane when pane has changed.
}

export function setCurrentPrimaryPaneOptionComponent(sm, paneOptionComponentId) {
    if (sm.state['currentPrimaryPaneOptionComponentId'] !== paneOptionComponentId) {
        sm.commit('currentPrimaryPaneOptionComponentId', paneOptionComponentId)
    }
}

export function recordPaneOpen(sm, pane) {
    let openedPaneIds = [].concat(sm.state['openedPaneIds']);
    if (!openedPaneIds.includes(pane.identifier)) {
        openedPaneIds.push(pane.identifier);
        sm.commit('openedPaneIds', openedPaneIds);
    }
}

export function setCurrentMapFilterCode(sm, mapFilterCode) {
    if (sm.state['currentMapFilterCode'] !== mapFilterCode) {
        sm.commit('currentMapFilterCode', mapFilterCode)
    }
}

export function recordMapFilterOpen(sm, mapFilterCode) {
    let openedMapFilterCodes = [].concat(sm.state['openedMapFilterCodes']);
    openedMapFilterCodes.push(mapFilterCode);
    sm.commit('openedMapFilterCodes', openedMapFilterCodes);
}

export function recordPaneOptionsComponentOpenState(sm, payload={}) {
    const { paneOptionsComponent, open: newOpenState } = payload;
    const componentId = paneOptionsComponent.identifier;
    
    // Get existing state for the componet or empty object if none exists
    const existingComponentState = sm.state['paneOptionsComponents'][componentId] || {};
    
    // Exit early if no state change needed
    if (existingComponentState.open === newOpenState) return;
    
    // Create new state object immutably
    const updatedState = {
        ...sm.state['paneOptionsComponents'],
        [componentId]: {
            ...existingComponentState,
            open: newOpenState
        }
    };
    
    sm.commit('paneOptionsComponents', updatedState);
}
